import { useEffect, useState } from 'react';
import { facebookAdAccountService, MetaAdAccount } from '@/services/facebook-ad-account.service';

interface State {
  loading: boolean;
  account: MetaAdAccount | null;
  currency: string | null;
}

let cached: MetaAdAccount | null | undefined;
const listeners = new Set<(acc: MetaAdAccount | null) => void>();

async function load() {
  try {
    cached = await facebookAdAccountService.get();
  } catch {
    cached = null;
  }
  listeners.forEach((l) => l(cached ?? null));
}

export function useMetaAccountCurrency(): State {
  const [account, setAccount] = useState<MetaAdAccount | null>(cached ?? null);
  const [loading, setLoading] = useState<boolean>(cached === undefined);

  useEffect(() => {
    const onChange = (acc: MetaAdAccount | null) => setAccount(acc);
    listeners.add(onChange);
    if (cached === undefined) {
      setLoading(true);
      load().finally(() => setLoading(false));
    }
    return () => { listeners.delete(onChange); };
  }, []);

  return { loading, account, currency: account?.currency ?? null };
}
